<script setup lang="ts">
import Button from 'primevue/button';
import TimesIcon from '@primeicons/vue/times';

type Emits = {
  (e: 'close'): void;
}

const emit = defineEmits<Emits>();
</script>
<template>
  <section class="flex flex-col rounded-lg border px-4 py-3 lg:p-6">
    <div class="flex items-center justify-end">
      <Button
        icon-only
        severity="secondary"
        variant="text"
        aria-label="Close"
        rounded
        @click="emit('close')"
      >
        <TimesIcon />
      </Button>
    </div>
    <div class="flex">
      <slot />
    </div>
  </section>
</template>
